import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Column, GridContainer, Row, Typography } from '@vp/swan';
import { DebugModeContext } from '../../contexts/DebugModeContext';
import { InternalViewContext } from '../../contexts/InternalViewContext';
import { ActiveOrderControl } from '../../shared/internalView/ActiveOrderControl';
import { DesignFeedbackGroupApplication } from './DesignFeedbackGroupApplication';

export const InternalViewDesignFeedbackGroupApplication = ({
  orderId,
  groupId,
}) => {
  const { setDebugEnabled } = useContext(DebugModeContext);
  setDebugEnabled(true);

  const {
    internalViewerSuppliedShopperId,
    internalViewSuppliedOrderId,
    internalViewSuppliedGroupId,
  } = useContext(InternalViewContext);

  const showDesignFeedbackApplication =
    internalViewerSuppliedShopperId &&
    internalViewSuppliedOrderId &&
    internalViewSuppliedGroupId;

  return (
    <>
      <GridContainer>
        <Row mt={7} mb={3}>
          <Column span={12}>
            <Typography fontSize="x2large" textAlign="center" mb={6}>
              Welcome to Design Feedback Internal View
            </Typography>
          </Column>
        </Row>
        <Row mb={7}>
          <Column span={6} push={3}>
            <ActiveOrderControl
              defaultOrderId={orderId}
              defaultGroupId={groupId}
              collectGroupId
            />
          </Column>
        </Row>
      </GridContainer>
      {showDesignFeedbackApplication && (
        <DesignFeedbackGroupApplication
          shopperId={internalViewerSuppliedShopperId}
          orderId={internalViewSuppliedOrderId}
          groupId={internalViewSuppliedGroupId}
        />
      )}
    </>
  );
};

InternalViewDesignFeedbackGroupApplication.propTypes = {
  orderId: PropTypes.string.isRequired,
  groupId: PropTypes.string.isRequired,
};
